import { ISLAND_BY_PATH } from "@/lib/translations";

// Alte privateholiday.de-Adressen (PHP/.html) → neue Pfade. null = kein Altpfad.
const ROOT_MAP = { kontakt: "/kontakt", impressum: "/impressum", datenschutz: "/datenschutz", login: "/kunde/login", "ueber-uns": "/", vermieter: "/vermieter-werden", kanaren: "/" };
const FOREIGN = new Set(["mallorca", "ibiza", "balearen", "deutschland", "bayern", "bremen", "baden-wuerttemberg", "nordrhein-westfalen", "nordsee", "ostsee", "schleswig-holstein", "brandenburg", "niedersachsen", "hessen", "sachsen", "thueringen", "mecklenburg-vorpommern", "rheinland-pfalz", "saarland", "sachsen-anhalt", "hamburg", "berlin", "italien", "kroatien", "luxemburg", "spanien", "portugal", "madeira", "oesterreich", "schweiz", "frankreich", "griechenland", "tuerkei"]);
const GONE = new Set(["langzeitvermietung", "immobilien-kaufen"]); // alte Rubriken ohne Entsprechung → Inselseite
// Alte Rubrikseiten der Vorgängerseite („/ferienwohnung-mit-pool“, „/finca“ …) → Objektsuche
const CATEGORY = /^(ferienwohnung|ferienwohnungen|ferienhaus|ferienhaeuser|finca|fincas|villa|villen|apartment|appartement|bungalow|studio|landhaus)(-|$)/;
const isGallery = (s) => /^(galerie|suche|objekt|detail)(-\d+)?(\.html)?$/.test(s);

// Nur Alt-Adressen mit eindeutigem Muster synchron umleiten. Das Präfix „ferienwohnung-<ort>“ kollidiert mit echten Objekt-Slugs
// (z. B. ferienwohnung-mit-meerblick-in-el-sauzal) und wird deshalb erst in PlacePage geprüft (legacyPlaceAlt), wenn kein Objekt existiert.
const placeSlug = (s) => s.replace(/-ferienwohnung-ferienhaus$/, "");
export const legacyPlaceAlt = (s) => { const alt = s.replace(/^ferienwohnung-(?=.)/, ""); return alt !== s ? alt : null; };

export const legacyTarget = (pathname) => {
  const parts = pathname.replace(/\/+$/, "").split("/").filter(Boolean);
  if (!parts.length) return null;
  const first = parts[0].replace(/\.html$/, "");
  if (FOREIGN.has(first)) return "/";
  const isHtml = /\.html$/.test(parts[parts.length - 1]);
  if (parts.length === 1) {
    if (isGallery(first)) return "/";
    if (CATEGORY.test(first)) return "/properties";
    if (!isHtml) return first === "kanaren" ? "/" : null;
    return ROOT_MAP[first] || `/${first}`;
  }
  if (!ISLAND_BY_PATH[parts[0]]) return null;
  if (GONE.has(parts[1].replace(/\.html$/, ""))) return `/${parts[0]}/`;
  if (isGallery(parts[1])) return `/${parts[0]}/`;
  if (parts.length === 3 && /^galerie-lage/.test(parts[2])) return `/${parts[0]}/${placeSlug(parts[1].replace(/\.html$/, ""))}/`;
  if (parts.length === 2) {
    const raw = parts[1].replace(/\.html$/, "");
    const slug = placeSlug(raw);
    if (isHtml || slug !== raw) return `/${parts[0]}/${slug}/`;
  }
  return null;
};
